import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CostSection() {
  const errors = [{
    situation: 'Error 1: Más kilómetros no es más progreso',
    cost: 'Cada km extra sin estructura es desgaste innecesario'
  }, {
    situation: 'Error 2: Los planes genéricos no están hechos para vos',
    cost: 'Ilusión de hacer algo. Cero adaptación a tu cuerpo.'
  }, {
    situation: 'Error 3: Correr con dolor y seguir adelante',
    cost: 'No te hace más duro. Te lleva a una lesión seria.'
  }, {
    situation: 'Error 4: Sin técnica, el esfuerzo te destruye',
    cost: 'Más zancadas mal hechas = más daño articular.'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-54">
      <FadeIn data-id="element-55">
        <div className="text-center mb-6 md:mb-14" data-id="element-56">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#ef4444]/10 mb-3 md:mb-6 border border-[#ef4444]/20" data-id="element-57">
            <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-58">
              ⚠️
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] mb-2 md:mb-4 px-2" data-id="element-59">
            ¿POR QUÉ NO MEJORÁS?
          </h2>
          <p className="text-sm md:text-xl text-[#475569] font-bold" data-id="element-60">
            La verdad que nadie te dice. El problema no sos vos. Es la falta de
            método.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8" data-id="element-61">
        {errors.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-62">
            <motion.div whileHover={{
          scale: 1.02
        }} className="bg-white border border-[#e2e8f0] hover:border-[#ef4444]/50 rounded-2xl p-4 md:p-6 flex flex-col justify-between h-full group relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-63">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ef4444]/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-[#ef4444]/10 transition-colors" data-id="element-64"></div>

              <p className="text-sm md:text-base text-[#0f172a] font-bold mb-3 md:mb-4 relative z-10" data-id="element-65">
                {item.situation}
              </p>

              <div className="flex items-center gap-2 md:gap-3 bg-[#ef4444]/5 p-3 md:p-4 rounded-xl border border-[#ef4444]/10 relative z-10" data-id="element-66">
                <AlertOctagon className="text-[#ef4444] shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-67" />
                <span className="font-black text-[#ef4444] text-sm md:text-lg leading-tight" data-id="element-68">
                  {item.cost}
                </span>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-69">
        <div className="bg-[#020617] rounded-2xl p-6 md:p-8 border border-[#22c55e]/30 shadow-lg max-w-3xl mx-auto text-center relative overflow-hidden" data-id="element-70">
          <div className="absolute inset-0 bg-[#22c55e]/5 blur-3xl rounded-full" data-id="element-71"></div>
          <p className="text-[#ef4444] font-black text-lg md:text-2xl mb-4 relative z-10" data-id="element-72">
            ¿Cuántos meses más vas a seguir corriendo igual?
          </p>
          <div className="w-full h-px bg-[#e2e8f0]/20 my-4 relative z-10" data-id="element-73"></div>
          <p className="text-[#f8fafc] font-bold text-base md:text-xl mb-4 relative z-10" data-id="element-74">
            Cada día sin sistema es un día más de kilómetros al pedo.
          </p>
          <ul className="text-[#4ade80] text-sm md:text-lg font-medium space-y-2 mb-6 relative z-10" data-id="element-75">
            <li data-id="element-76">✅ Diagnóstico real antes de cada salida</li>
            <li data-id="element-77">✅ Estructura que respeta tu nivel y tu agenda</li>
            <li data-id="element-78">✅ Progresión medible semana a semana</li>
            <li data-id="element-79">✅ Técnica que protege tus articulaciones</li>
          </ul>
          <p className="text-[#22c55e] font-black text-xl md:text-3xl drop-shadow-[0_0_10px_rgba(34,197,94,0.3)] relative z-10" data-id="element-80">
            El cambio empieza con una decisión.
          </p>
        </div>
      </FadeIn>
    </section>;
}